export enum TextVariantsEnum {
  hero = 'hero',
  heading = 'heading',
  body = 'body',
  bodySmall = 'bodySmall',
}

export type TextVariants = keyof typeof TextVariantsEnum;
